
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { saveFontFile } from "@/lib/fonts/backend";
import FileUpload from "@/components/Reusable/CustomInputs/FileUpload.vue";
import { pipe } from "fp-ts/lib/function";
import { fold } from "fp-ts/lib/Either";
import { _Error, logErrorsToUiStore } from "@/lib/wordpress/data";
import NotificationLogger from "@/lib/notifications/notifications";
@Component({
  components: { FileUpload }
})
export default class FontFileUpload extends Vue {
  saveInProgress = false;

  handleFiles(files: FileList) {
    Array.from(files).forEach((file: File) => {
      const fileReader = new FileReader();
      fileReader.onloadend = async e => {
        if (!e?.target) return;

        // Get the file's MIME type to validate the file type
        // This is reliable in contrast to checking the extension
        // https://stackoverflow.com/questions/18299806/how-to-check-file-mime-type-with-javascript-before-upload

        const arr = new Uint8Array(
          e.target.result as Iterable<number>
        ).subarray(0, 4);
        let header = "";
        arr.forEach(value => (header += value.toString(16)));

        const extension = file.name.split(".").pop();
        // https://en.wikipedia.org/wiki/List_of_file_signatures
        const isWoff = header === "774f4646" && extension === "woff";
        const isWoff2 = header === "774f4632" && extension === "woff2";

        if (!(isWoff || isWoff2)) {
          NotificationLogger.log.message(
            'Only  ".woff" and ".woff2" files are supported'
          );

          return;
        }

        this.saveInProgress = true;

        pipe(
          await saveFontFile(file),
          fold(
            (errors: _Error[]) => {
              logErrorsToUiStore(errors);
            },
            r => {
              this.$emit("save", {
                fileUrl: r.fileUrl,
                format: isWoff ? "woff" : "woff2",
                fileName: r.fileName
              });
            }
          )
        );

        this.saveInProgress = false;
      };

      fileReader.readAsArrayBuffer(file);
    });
  }
}
